import React, { Component } from "react";
import HeaderNav from "./ecommerce/HeaderNav";
import Hero from "./ecommerce/MainHero";
import Tickets from "./ecommerce/MainTickets";
import RemainingCardsEnvelopes from "./ecommerce/RemainingCardsEnvelopes";
import LargestJackpot from "./ecommerce/MainLargestJackpot";
import HowItWorks from "./ecommerce/MainHowItWorks"
import Countdown from './ecommerce/Countdown';

// const defaultEvent = {
//   "id": 1,
//   "title": "DEMO RAFFLE WEEK 1",
//   "date": "2020-05-19",
//   "start_at": "2020-04-01 10:30:00",
//   "end_at": "2020-05-19 08:10:00",
//   "prices": { "5": 10, "20": 20, "80": 40, "250": 100 },
//   "pricing": "default",
//   "jackpot": 91944,
//   "prize": 0,
//   "draws": [
//     { "title": "Weekly Prize", "number": null, "jackpot": "91944.00", "prize": "0.00", "is_grand": 1, "draw_at": null, "first_name": null, "last_name": null, "card": false, "winning_card": false }
//   ],
//   "nonprofit": {
//     "id": 1, "name": "DEMO ORGANIZATION",
//     "pri_email": null,
//     "pri_phone_number": null
//   }
//   , "game": {
//     "id": 3,
//     "title": "Catch the Ace",
//     "label": null,
//     "description": "The raffle sales are divided into three parts. Typically the organizers keep 50%, the winner of the weekly lottery takes 20%, and the remaining 30% goes into the jackpot.",
//     "created_at": "2019-08-15 13:16:23",
//     "updated_at": "2019-08-28 11:55:04",
//     "deleted_at": null
//   },
//   "beneficiaries": [],
//   "beneficiaryenabled": 1,
//   "is_active": true,
//   "cards": [{ "envelope": 1, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 2, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 3, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 4, "drawn": true, "rank": "A", "suit": "D" }, { "envelope": 5, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 6, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 7, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 8, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 9, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 10, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 11, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 12, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 13, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 14, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 15, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 16, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 17, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 18, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 19, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 20, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 21, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 22, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 23, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 24, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 25, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 26, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 27, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 28, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 29, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 30, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 31, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 32, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 33, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 34, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 35, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 36, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 37, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 38, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 39, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 40, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 41, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 42, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 43, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 44, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 45, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 46, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 47, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 48, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 49, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 50, "drawn": false, "rank": "?", "suit": "?" }, { "envelope": 51, "drawn": true, "rank": "3", "suit": "S" }, { "envelope": 52, "drawn": true, "rank": "J", "suit": "S" }]
// }


class WebSalesTemplate extends Component {


  render() {
    
    const { colorPallete, settings, language, event } = this.props;    

    return (

      <div className="main font-sans" style={colorPallete}>

        {settings && language &&
          <header className="bg-primary text-accent">
            <HeaderNav
              settings={settings}
              language={language}
            />
            <div>
              <Hero event={event} language={language} settings={settings} />
              <Tickets event={event} />
              {+settings.web_show_cards_remaining_home_page === 1 && <RemainingCardsEnvelopes event={event} settings={settings} />}              
              {+settings.web_countdown_enabled === 1 && <Countdown date={event.end_at} />}
              {+settings.display_largest_jackpot === 1 && <LargestJackpot event={event} language={language} />}
              <HowItWorks event={event} settings={settings} language={language} />
            </div>
          </header>
        }      
      </ div>
    );
  }
}

export default WebSalesTemplate;
